import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WirepasNetworkGrid = _resolveComponent("WirepasNetworkGrid")!
  const _component_WirepasTopologyGraph = _resolveComponent("WirepasTopologyGraph")!
  const _component_WirepasAnchorPlacementGrid = _resolveComponent("WirepasAnchorPlacementGrid")!
  const _component_WirepasFleetHealthGrid = _resolveComponent("WirepasFleetHealthGrid")!
  const _component_WirepasDataCleanupGrid = _resolveComponent("WirepasDataCleanupGrid")!
  const _component_WirepasMqttConsoleGrid = _resolveComponent("WirepasMqttConsoleGrid")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Tabs, null, {
        "tab-selector": _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'network' }, "tab-link"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'network'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.network')), 3),
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'topology' }, "tab-link"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'topology'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.topology')), 3),
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'anchorPlacement' }, "tab-link"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'anchorPlacement'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.anchorPlacement')), 3),
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'fleetHealth' }, "tab-link"]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'fleetHealth'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.fleetHealth')), 3),
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'dataCleanup' }, "tab-link"]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'dataCleanup'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.dataCleanup')), 3),
          _createElementVNode("button", {
            class: _normalizeClass([{ active: _ctx.activeTab === 'mqttConsole' }, "tab-link"]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'mqttConsole'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.tabs.mqttConsole')), 3)
        ]),
        "tab-content": _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasNetworkGrid, {
              active: _ctx.activeTab === 'network'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'network']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasTopologyGraph, {
              active: _ctx.activeTab === 'topology'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'topology']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasAnchorPlacementGrid, {
              active: _ctx.activeTab === 'anchorPlacement'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'anchorPlacement']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasFleetHealthGrid, {
              active: _ctx.activeTab === 'fleetHealth'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'fleetHealth']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasDataCleanupGrid, {
              active: _ctx.activeTab === 'dataCleanup'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'dataCleanup']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_WirepasMqttConsoleGrid, {
              active: _ctx.activeTab === 'mqttConsole'
            }, null, 8, ["active"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'mqttConsole']
          ])
        ]),
        _: 1
      })
    ])
  ]))
}